import PricingTable from "../../../../src/components/Pricing/PricingTable";
import * as React from 'react';
export default {
  PricingTable,
  React
};